import React from 'react';
import { CreateCustomer as Create, Layout } from '@components/customers';

const CreateCustomer = () => {
    return <Create />;
};

CreateCustomer.Layout = Layout;
export default CreateCustomer;
